var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 258,
    rx: 129,
    fill: "#292836",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_33000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 258
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 129C0.5 0 0.5 0 129.5 0C258.5 0 258.5 0 258.5 129C258.5 200.245 200.745 258 129.5 258C58.2553 258 0.5 200.245 0.5 129Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_33000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8_33000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 20,
    width: 182,
    height: 238,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 141,
    width: 138,
    height: 31,
    rx: 4,
    fill: "#4F830F14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 95,
    width: 76,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 114,
    width: 76,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 93,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#4F830F14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 97,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#4F830F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 112,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 68,
    width: 138,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 49,
    width: 138,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0981 163.324C74.8947 156.897 86.8606 145.008 88.3511 148.864C90.2143 153.684 75.9298 165.734 82.1405 164.529C88.3511 163.324 98.9092 148.864 99.5303 152.881C100.151 156.897 95.8039 162.119 97.6671 162.119C99.5303 162.119 113.194 152.881 112.573 156.094C111.952 159.307 103.257 165.734 114.436 162.119C125.615 158.504 128.099 157.751 140.52 157.349C152.942 156.948 162.258 158.554 172.816 160.964",
    stroke: "#4F830F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 20.5,
    width: 181,
    height: 237,
    rx: 7.5,
    stroke: "#EBEAEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8_33000",
    x: 18,
    y: 20,
    width: 222,
    height: 278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_33000"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_33000"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8_33000"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8_33000",
    result: "effect2_dropShadow_8_33000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8_33000",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormEmptyState);
export default __webpack_public_path__ + "static/media/form-empty-state.c2cb7b52.svg";
export { ForwardRef as ReactComponent };